import React, { Component } from 'react'

export default WrappElement => (class TimeoutMixin extends Component {
    componentWillMount() {
        this.timeouts = []
        this.intervals = []
    }

    setTimeout() {
        return this.timeouts.push( setTimeout.apply( null, arguments ) ) - 1
    }

    setInterval() {
        return this.intervals.push( setInterval.apply( null, arguments ) ) - 1
    }

    clearTimeout( id ) {
        clearTimeout( this.timeouts[ id ] )
    }

    clearInterval( id ) {
        console.log( 'Clear interval by intervalID', id )

        clearInterval( this.intervals[ id ] )
    }

    clearTimeouts() {
        console.log( '[Timeout][clearTimeouts]', {
            intervals: this.intervals,
            timeouts: this.timeouts
        })

        this.timeouts.forEach( (fn, id) => this.clearTimeout( id ) )
        this.intervals.forEach( (fn, id) => this.clearInterval( id ) )
    }

    componentWillUnmount() {
        console.log( '[Timeout][Lifecircle][WillUnmount]' )

        this.clearTimeouts()
    }

    render() {
        const props = {
            ...this.props,
            setTimeout: ::this.setTimeout,
            setInterval: ::this.setInterval,
            clearTimeout: ::this.clearTimeout,
            clearInterval: ::this.clearInterval,
            clearTimeouts: ::this.clearTimeouts
        }

        return (
            <WrappElement { ...props } />
        )
    }
})